import { Text } from "@clipboard-health/ui-components";
import { Box, LinearProgress, Stack } from "@mui/material";
import pluralize from "pluralize";

interface SubCategoryRatingBarProps {
  label: string;
  rating: number;
  ratingsCount: number;
}

export function SubCategoryRatingBar(props: SubCategoryRatingBarProps) {
  const { label, rating, ratingsCount } = props;

  return (
    <Stack spacing={1}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Text variant="body2" color={(theme) => theme.palette.text.primary}>
          {label}{" "}
          <Box component="span" sx={(theme) => ({ color: theme.palette.text.secondary })}>
            ({ratingsCount} {pluralize("rating", ratingsCount)})
          </Box>
        </Text>
        <Text semibold variant="body2" color={(theme) => theme.palette.text.primary}>
          {rating.toFixed(1)}
        </Text>
      </Stack>
      <LinearProgress
        variant="determinate"
        value={(rating / 5) * 100}
        sx={(theme) => ({
          height: 6,
          borderRadius: 3,
          backgroundColor: theme.palette.action.hover,
          "& .MuiLinearProgress-bar": {
            borderRadius: 3,
            backgroundColor: theme.palette.primary.main,
          },
        })}
      />
    </Stack>
  );
}
